import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useAppActions, useAppSelector} from '../../../../../hooks/runtime'
import {getTicketDetails, getUseBuyerDetails} from '../../../../../selectors/checkout'
import {getSelectedTicketsQuantity} from '../../../../../selectors/selected-tickets'
import {Checkbox} from '../../../../form/commons/checkbox'
import {DISABLED_MANDATORY_FIELDS} from '../../../../form/constants'
import {Form} from '../../../../form/container'
import s from '../ticket-details.scss'
import {TicketDetailsFormProps} from './interfaces'

export const TicketDetailsForm = ({
  expanded,
  ticketIndex,
  formId,
  toggleUseBuyerDetails,
  submitTicketDetails,
}: TicketDetailsFormProps) => {
  const {t} = useTranslation()
  const {setTicketDetails} = useAppActions()

  const details = useAppSelector(state => getTicketDetails(state, ticketIndex))
  const selectedTicketsQuantity = useAppSelector(getSelectedTicketsQuantity)
  const useBuyerDetails = useAppSelector(getUseBuyerDetails)

  return expanded ? (
    <div>
      <div className={s.divider} />
      {!ticketIndex && (
        <div className={s.checkbox}>
          <Checkbox
            value={t('mobile.checkout.ticket.useBuyerDetails') as string}
            checked={useBuyerDetails}
            dataHook={DH.SAME_AS_BUYER_CHECKBOX}
            onChange={toggleUseBuyerDetails}
          />
        </div>
      )}
      <div className={s.form}>
        <Form
          isTicketForm
          form={formId}
          initialValues={details}
          disabledFields={!ticketIndex && useBuyerDetails ? DISABLED_MANDATORY_FIELDS : emptyArr}
          isLastTicket={ticketIndex === selectedTicketsQuantity - 1}
          setTicketDetails={setTicketDetails}
          onFormSubmit={submitTicketDetails}
        />
      </div>
    </div>
  ) : null
}

const emptyArr = []
